<script>
  import { PageHeader } from 'element-ui'
  export default {
    name:'ElPageHeader',
    extends:PageHeader
  }
</script>
